import React from "react";
import Text from "../text";
import { Container, Title, Content } from "./styled-components";

const ResumeCard = ({ title, description }: ResumeCardProps) => {
  return (
    <Container>
      <Title>
        <Text size="14px" color="grey500">
          RAPPEL DE VOS CHOIX
        </Text>
      </Title>
      <Content>
        <Text align="center" size="20px" color="grey400" lineHeight="30px">
          {title}
        </Text>
        <Text align="center" weight={700} size="24px" lineHeight="36px">
          {description}
        </Text>
      </Content>
    </Container>
  );
};

export default ResumeCard;
